<template>
<div class="row">

  <div class="col-12">
    <div>
      <label for="slot">{{$t('message.schedules.select_time_slot_number')}}</label>
      <multiselect id="slot" class="slot-options" v-model="slots" selected-label="" select-label="" deselect-label="" placeholder="" :options="slotOptions" :allow-empty="false"></multiselect>
      <p id="slotHelpInline" class="form-text text-muted">
        {{$t('message.schedules.time_slot_e_g')}}
      </p>
    </div>
    <div class="form-divider"></div>
  </div>

</div>
</template>

<script>

import jq from 'jquery'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    jq,
    Multiselect
  },
  props: {
    clinic_id: Number,
    doctor_id: Number,
    time_slots: Number,
    slot_options: Array
  },
  data () {
    return {
      slots: 30,
      slotOptions: [10, 15, 20, 30, 60].map(time => time.toString())
    }
  },
  watch: {
    slots (v, old) {
      if (v) {
        this.$emit('timeSlotsChanged', this.clinic_id, parseInt(v))
      }
    }
  },
  created () {
    if (this.time_slots) {
      this.slots = this.time_slots
    }

    if (this.slot_options) {
      this.slotOptions = this.slot_options
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.form-divider{
  height: 1px;
  border: 1px dashed #eee;
  margin: 10px 0;
  width: 100%;
}

.slot-options {
  width: 4.5rem !important;
  text-align-last: center;
}

</style>



// WEBPACK FOOTER //
// WorkingTimeSlot.vue?f92346b8